module.exports = __webpack_public_path__ + "static/Logo Palletways-b0c7fdc25210898f23261797abfd905d.png";